const getReportPath = (type) => {
  switch (type) {
    case "BPM Principal v2":
      return "view";
    case "INFORME FOTOS":
      return "viewImages";
    case "FATIGA Y SOMNOLENCIA GENERAL TALTAL 2025":
      return "viewGeneralDrowsiness";
    case "FATIGA Y SOMNOLENCIA POR HABITACIÓN TALTAL 2025":
      return "viewRoomDrowsiness";
    case "TALTAL HOTELEROS 2025":
      return "viewHoteliers";
    default:
      return "view";
  }
};

export default getReportPath;